import { createCollectionReducer } from 'reducers/account/collections';
import { TYPE } from './constants';

export default createCollectionReducer(TYPE);

export const selectProfileAttributes = state => state.account?.[TYPE];
export const selectProfileAttribute = (state, name) =>
  selectProfileAttributes(state)?.[name];
